export default __webpack_public_path__ + "static/media/footwear.2e290bf2.png";